module.exports = __webpack_public_path__ + "static/img/my2.8a95773a.png";